import 'regenerator-runtime/runtime';
import '../src/styles/cercalia.scss';
import cercaliagl$$Map from '../src/cercaliagl/Map.js';
import cercaliagl$$LonLat from '../src/cercaliagl/LonLat.js';
import cercaliagl$$Marker from '../src/cercaliagl/Marker.js';
import cercaliagl$$Popup from '../src/cercaliagl/Popup.js';
import cercaliagl$$Icon from '../src/cercaliagl/Icon.js';
// #CODE

const map = new cercaliagl$$Map({
  target: 'map',
});

map.whenReady(() => {
  const arrayMarkers = [];

  const markerBcn = new cercaliagl$$Marker({
    position: new cercaliagl$$LonLat(2.165802217, 41.392919622),
    popup: new cercaliagl$$Popup({
      title: 'Barcelona',
      content: 'Barcelona Marker <b>content</b>',
      visible: true,
      offset: [0, -40],
    }),
  });

  const markerMadrid = new cercaliagl$$Marker({
    position: new cercaliagl$$LonLat(-3.715090655, 40.426123994),
    icon: new cercaliagl$$Icon({
      src: 'resources/img/cercalia-marker-icon-A.png',
    }),
    popup: new cercaliagl$$Popup({
      title: 'Madrid',
      content: '<b>Content</b> of <strong style="color:red">popup</strong>',
      visible: true,
      offset: [0, -25],
      closeOnTime: 5000,
    }),
  });

  const markerSevilla = new cercaliagl$$Marker({
    position: new cercaliagl$$LonLat(-6.005183775, 37.38),
    icon: new cercaliagl$$Icon({
      src: 'resources/img/cercalia-marker-icon-A.png',
      opacity: 0.5,
    }),
    popup: new cercaliagl$$Popup({
      title: 'Sevilla',
      content: '<i>Ciudad de Sevilla</i>',
      visible: true,
      offset: [0, -25],
    }),
  });

  arrayMarkers.push(markerBcn);
  arrayMarkers.push(markerMadrid);
  arrayMarkers.push(markerSevilla);

  // Añadimos markers al mapa
  map.addMarkers(arrayMarkers);
  map.centerToMarkers(arrayMarkers, {
    changeZoom: true,
    animation: false,
  });

  setTimeout(() => {
    map.closePopups();
  }, 5000);
});
